class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();

    this.header = document.querySelector(".section-header");
    this.annoucementBar = document.querySelector(".announcement-bar-section");
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 989px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);

    if (this.header) {
      this.header.classList.add("reset-z-index");
    }
    if (this.annoucementBar) {
      this.annoucementBar.classList.add("reset-z-index");
    }

    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    document.body.classList.remove(`overflow-hidden-undefined`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    setTimeout(() => {
      if (this.header) {
        this.header.classList.remove("reset-z-index");
      }
      if (this.annoucementBar) {
        this.annoucementBar.classList.remove("reset-z-index");
      }
    }, 400);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("mobile-menu-nav", HeaderDrawer);

class FadeSlider extends HTMLElement {
  constructor() {
    super();

    this.sliderItems = this.querySelectorAll("li.grid__item.slider__slide");

    this.observeItems();
  }

  observeItems() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("show", entry.isIntersecting);
        });
      },
      {
        threshold: 0.5,
      }
    );

    this.sliderItems.forEach((card) => {
      observer.observe(card);
    });
  }
}

customElements.define("fade-slider", FadeSlider);

class UGCProductPopout extends HTMLElement {
  constructor() {
    super();

    this.openButton = this.querySelector(".ugc-open-products-button");

    if (this.openButton) {
      this.openButton.addEventListener("click", () => {
        this.classList.toggle("open");
      });
    }
  }
}

customElements.define("ugc-product-popout", UGCProductPopout);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (this.initialized) return;

    if (this.classList.contains("slideshow")) {
      this.slider = this;
    } else {
      this.slider = this.querySelector('[id^="Slider-"]');
    }

    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping =
      this.getAttribute("data-enable-looping") === "true" ? true : false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;
    if (this.sliderItems.length === 0) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton?.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton?.addEventListener("click", this.onButtonClick.bind(this));
    this.initialized = true;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    // Update active state on nav dots
    const navs = this.querySelectorAll(".product-slider-counter--nav");
    navs.forEach((nav) => {
      const dots = nav.querySelectorAll(".product-slider-counter--dot-button");
      dots.forEach((dot, index) => {
        dot.classList.toggle("active", index + 1 === this.currentPage);
      });
    });

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton?.setAttribute("disabled", "disabled");
    } else {
      this.prevButton?.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton?.setAttribute("disabled", "disabled");
    } else {
      this.nextButton?.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    if (
      event.currentTarget.classList.contains(
        "product-slider-counter--dot-button"
      )
    ) {
      const targetPage = parseInt(step, 10);
      if (!Number.isNaN(targetPage) && this.sliderItemOffset) {
        const slidesPerStep = Math.max(this.slidesPerPage || 1, 1);
        this.slider.scrollTo({
          left: this.sliderItemOffset * slidesPerStep * (targetPage - 1),
        });
      }
      return;
    }

    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    if (
      event.currentTarget.name === "next" &&
      this.currentPage === this.sliderItems.length
    ) {
      this.slideScrollPosition = 0;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  connectedCallback() {
    this.init();

    if (this.dataset.reset_scroll == "true" && this.slider) {
      this.slider.scrollLeft = 0;
    }

    this.querySelectorAll(".product-slider-counter--dot-button").forEach(
      (button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      }
    );
  }
}

customElements.define("slider-component", SliderComponent);

class SliderComponentCard extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="SliderCard-"]');
    this.sliderItems = this.querySelectorAll('[id^="SlideCard-"]');
    this.enableSliderLooping = false;
    this.pageNav = this.querySelector(".product-slider-counter--nav");
    this.sliderDots = this.querySelectorAll(
      ".product-slider-counter--nav .slider-counter--dot-button"
    );
    this.currentPageElement = this.querySelector(
      ".product-card-gallery .slider-counter--current"
    );
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous-card"]');
    this.nextButton = this.querySelector('button[name="next-card"]');

    // Snaps the carousel back to the first slide without animation & then restores the original scroll behavior
    this.resetToFirstSlide = () => {
      if (!this.slider) return;

      const previousBehavior = this.slider.style.scrollBehavior;
      this.slider.style.scrollBehavior = "auto";
      this.slider.scrollLeft = 0;

      requestAnimationFrame(() => {
        if (previousBehavior) {
          this.slider.style.scrollBehavior = previousBehavior;
        } else {
          this.slider.style.removeProperty("scroll-behavior");
        }

        this.slider.classList.add("slider-ready");
      });
    };

    if (this.pageNav && this.sliderDots) {
      this.sliderDots.forEach((dot) =>
        dot.addEventListener("click", this.onButtonClick.bind(this))
      );
    }

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.updateNav(this.totalPages);
    this.update();
    if (!this.slider.classList.contains("slider-ready")) {
      requestAnimationFrame(() => this.resetToFirstSlide());
    }
  }

  updateNav(items) {
    if (!this.pageNav) return;

    let totalDots = items;
    for (let i = 0; i < this.pageNav.children.length; i++) {
      let tableChild = this.pageNav.children[i];
      tableChild.classList.add("hidden");
    }
    if (totalDots > this.pageNav.children.length) {
      totalDots = this.pageNav.children.length;
    }
    for (let i = 0; i < totalDots; i++) {
      this.pageNav
        .getElementsByClassName(`dot-card-${i + 1}`)[0]
        .classList.remove("hidden");
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="SlideCard-"]');
    this.slider?.classList.remove("slider-ready");
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if (this.pageNav && this.sliderDots) {
      for (let i = 0; i < this.pageNav.children.length; i++) {
        let tableChild = this.pageNav.children[i];
        tableChild.classList.remove("active");
      }

      if (
        this.pageNav.getElementsByClassName(`dot-card-${this.currentPage}`)[0]
      ) {
        this.pageNav
          .getElementsByClassName(`dot-card-${this.currentPage}`)[0]
          .classList.add("active");
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const currentTarget = event.currentTarget;

    // If it's a dot button, scroll to the corresponding slide
    if (
      currentTarget.classList.contains("product-slider-counter--dot-button")
    ) {
      const step = parseInt(currentTarget.dataset.step, 10) || 1;
      const targetSlide = this.querySelector(
        `#SlideCard-${this.slider.id.replace("SliderCard-", "")}-${step - 1}`
      );
      if (targetSlide) {
        this.slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: "smooth",
        });
      }

      // Update active state on dots
      this.sliderDots.forEach((dot) => dot.classList.remove("active"));
      currentTarget.classList.add("active");
      return;
    }

    // Otherwise, handle prev/next
    let step = parseInt(currentTarget.dataset.step) || 1;
    this.slideScrollPosition =
      currentTarget.name === "next-card"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: "smooth",
    });
  }

  mouseDownHandler(e) {
    this.slider.classList.add("grabbing");
    this.slider.style.userSelect = "none";

    const pos = {
      left: this.slider.scrollLeft,
      top: this.slider.scrollTop,
      x: e.clientX,
      y: e.clientY,
    };

    const mouseMoveHandler = (e) => {
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      this.slider.scrollTop = pos.top - dy;
      this.slider.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = () => {
      this.slider.classList.remove("grabbing");
      this.slider.style.removeProperty("user-select");

      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
    };

    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("mouseup", mouseUpHandler);
  }

  connectedCallback() {
    if (!this.slider) return;

    // Wait for browser pageshow & fire resetToFirstSlide
    if (!this.pageShowHandler) {
      this.pageShowHandler = (event) => {
        if (!event.persisted) return;
        requestAnimationFrame(() => this.resetToFirstSlide());
      };
    }

    window.addEventListener("pageshow", this.pageShowHandler);
  }

  disconnectedCallback() {
    if (this.pageShowHandler) {
      window.removeEventListener("pageshow", this.pageShowHandler);
    }
  }
}

customElements.define("slider-card", SliderComponentCard);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.setupSlideshow();
  }

  connectedCallback() {
    super.connectedCallback();
    this.setupSlideshow();
  }

  setupSlideshow() {
    if (this.slideshowInitialized) return;

    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper || !this.slider) return;

    this.sliderFirstItemNode = this.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow?.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.getAttribute("data-autoplay") === "true") this.setAutoPlay();
    this.slideshowInitialized = true;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton?.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton?.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton?.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton?.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton?.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton?.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton?.classList.remove(
        "slideshow__autoplay--paused"
      );
      this.sliderAutoplayButton?.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ["data-url", "data-products-to-show"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!oldValue || oldValue === newValue) return;
    if (name !== "data-url" && name !== "data-products-to-show") return;
    this.loadRecommendations(this.dataset.url);
  }

  hideWhenEmpty() {
    if (this.dataset.hideWhenEmpty !== "true") return;
    this.classList.add("cross-sell--empty");
    this.classList.add("hidden");
    if (this.dataset.hideSection === "true") {
      const parentSection =
        document.getElementById(this.dataset.section_id) ||
        this.closest(".shopify-section");
      parentSection?.classList.add("hidden");
    }
  }

  findRecommendationsNode(html) {
    if (this.id) {
      const byId = html.querySelector(`#${CSS.escape(this.id)}`);
      if (byId) return byId;
    }

    const classMatchers = [
      "cross-sell",
      "complementary-products",
      "related-products",
    ];
    for (const className of classMatchers) {
      if (this.classList.contains(className)) {
        const match = html.querySelector(
          `product-recommendations.${CSS.escape(className)}`
        );
        if (match) return match;
      }
    }

    const nodes = html.querySelectorAll("product-recommendations");
    if (nodes.length === 1) return nodes[0];
    return null;
  }

  refreshBazaarvoiceWidgets() {
    try {
      if (window.$BV && typeof window.$BV.ui === "function") {
        window.$BV.ui("rr", "inline_ratings");
        return;
      }
      if (window.BV) {
        if (typeof window.BV.pixel?.trackPageView === "function") {
          window.BV.pixel.trackPageView();
        }
        if (typeof window.BV.configure === "function") {
          document.dispatchEvent(new CustomEvent("bv-ready"));
        }
      }
    } catch (e) {
    }
  }

  slideProductKey(slide) {
    const quickAddButton = slide.querySelector("[data-product-url]");
    if (quickAddButton?.dataset.productUrl) {
      return quickAddButton.dataset.productUrl.split("?")[0];
    }
    const link = slide.querySelector(".card__content[href], a[href]");
    return link ? link.getAttribute("href").split("?")[0] : "";
  }

  capCrossSellSlides(targetCount) {
    const slides = this.querySelectorAll(".cross-sell__slide");
    slides.forEach((slide, index) => {
      if (index >= targetCount) slide.remove();
    });
    this.syncCrossSellNav();
  }

  fillCrossSellFromFallback(targetCount) {
    return fetch(this.dataset.fallbackUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const fallbackRoot = this.findRecommendationsNode(html);
        if (!fallbackRoot) return;

        const list = this.querySelector(".cross-sell__slider");
        if (!list) {
          if (fallbackRoot.innerHTML.trim()) {
            this.innerHTML = fallbackRoot.innerHTML;
          }
          return;
        }

        const existing = new Set(
          Array.from(list.querySelectorAll(".cross-sell__slide")).map((slide) =>
            this.slideProductKey(slide)
          )
        );
        const slidePrefix = list.id.replace(/^Slider-/, "Slide-");

        fallbackRoot.querySelectorAll(".cross-sell__slide").forEach((slide) => {
          if (list.querySelectorAll(".cross-sell__slide").length >= targetCount) {
            return;
          }
          const key = this.slideProductKey(slide);
          if (!key || existing.has(key)) return;
          existing.add(key);
          list.appendChild(slide);
        });

        list.querySelectorAll(".cross-sell__slide").forEach((slide, index) => {
          slide.id = `${slidePrefix}-${index + 1}`;
        });

        this.syncCrossSellNav();
        this.querySelector("slider-component")?.resetPages?.();
      });
  }

  syncCrossSellNav() {
    const slides = this.querySelectorAll(".cross-sell__slide");
    const nav = this.querySelector(".cross-sell__progress");
    if (!nav || !slides.length) return;

    const template = nav.querySelector(".product-slider-counter--dot-button");
    if (!template) return;

    while (nav.children.length < slides.length) {
      const clone = template.cloneNode(true);
      clone.classList.remove("active");
      nav.appendChild(clone);
    }
    while (nav.children.length > slides.length) {
      nav.lastElementChild.remove();
    }

    nav.querySelectorAll(".product-slider-counter--dot-button").forEach((dot, index) => {
      dot.dataset.step = String(index + 1);
      dot.classList.toggle("active", index === 0);
    });
  }

  loadRecommendations(url, isFallback = false) {
    return fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = this.findRecommendationsNode(html);
        const hasContent =
          recommendations && recommendations.innerHTML.trim().length;

        if (hasContent) {
          this.innerHTML = recommendations.innerHTML;
        } else if (!isFallback && this.dataset.fallbackUrl) {
          return this.loadRecommendations(this.dataset.fallbackUrl, true);
        } else if (this.dataset.hideWhenEmpty === "true") {
          this.hideWhenEmpty();
          return;
        }

        const targetCount = parseInt(this.dataset.productsToShow, 10);
        if (this.classList.contains("cross-sell") && targetCount > 0) {
          this.capCrossSellSlides(targetCount);
        }
        if (
          !isFallback &&
          this.classList.contains("cross-sell") &&
          targetCount > 0 &&
          this.dataset.fallbackUrl &&
          this.querySelectorAll(".cross-sell__slide").length < targetCount
        ) {
          return this.fillCrossSellFromFallback(targetCount).then(() =>
            this.finalizeRecommendations()
          );
        }

        this.finalizeRecommendations();
      });
  }

  finalizeRecommendations() {
        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
          return;
        }

        const cards = this.querySelectorAll(".grid__item");

        const feature_card_enabled =
          this.dataset.feature_card_enabled === "true";
        if (feature_card_enabled) {
          const columns_desktop = parseInt(this.dataset.columns_desktop);
          const cards_fit_desktop = cards.length <= columns_desktop;
          const feature_wrap_el = document.querySelector(
            `#shopify-section-${this.dataset.section_id} .carousel__feature-wrap`
          );
          if (cards_fit_desktop) {
            feature_wrap_el.classList.add(
              "carousel__feature-wrap--cards-fit-desktop"
            );
          }
        }

        const parent_section = document.getElementById(this.dataset.section_id);

        const hide_recently_tab = this.dataset.hide_recently_tab === "true";
        const product_handle = this.dataset.product_handle;
        const product_handles_list = localStorage.getItem(
          "shopify_recently_viewed"
        );
        const no_recently_viewed =
          !product_handles_list ||
          product_handles_list == "" ||
          product_handles_list == product_handle;

        if (cards.length) {
          this.classList.add("product-recommendations--loaded");
          this.classList.remove("cross-sell--empty");
          this.refreshBazaarvoiceWidgets();
          requestAnimationFrame(() => this.refreshBazaarvoiceWidgets());
        } else if (this.dataset.hideWhenEmpty === "true") {
          this.hideWhenEmpty();
        } else if (hide_recently_tab || no_recently_viewed) {
          if (parent_section) {
            parent_section.classList.add("hidden");
          }
        } else if (parent_section) {
          const recommendationsEl = parent_section.querySelector(
            "product-recommendations"
          );
          const recently = parent_section.querySelector("recently-viewed");
          const recommendations_tab = parent_section.querySelector(
            ".product-recommendations-tab"
          );
          const recently_tab = parent_section.querySelector(
            ".recently-viewed-tab"
          );

          recommendations_tab?.classList.add("hidden");
          recently_tab?.classList.add("hidden");
          recommendationsEl?.classList.remove("active");
          recently?.classList.add("active");
        }
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.loadRecommendations(this.dataset.url).catch((e) => {
        console.error(e);
        this.hideWhenEmpty();
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/**
 * Fingerprint the products rendered inside a recommendations element so
 * `<crossell-product-recommendations>` / `<upsell-product-recommendations>`
 * can decide whether a fetched response actually changes the displayed set.
 * If the fingerprint matches the currently-rendered content, the innerHTML
 * replacement is skipped — preventing a redundant DOM swap that produces
 * a visible flicker when the cart drawer re-renders an already
 * server-populated cross-sell (GARP-160).
 *
 * Strategy: prefer the quick-add `data-product-url`; fall back to the
 * `.card__content[href]` PDP link; strip any query string so URL noise
 * (variant params, tracking) doesn't cause a false mismatch. Order is
 * preserved — a reordering still triggers a replace, which is correct.
 */
function refreshInlineRatings() {
  try {
    if (window.$BV && typeof window.$BV.ui === "function") {
      window.$BV.ui("rr", "inline_ratings");
    }
  } catch (e) {}
}

function fingerprintRecommendations(root) {
  return Array.from(root.querySelectorAll(".grid__item"))
    .map((item) => {
      const quickAddButton = item.querySelector("[data-product-url]");
      if (quickAddButton) return quickAddButton.dataset.productUrl;
      const link = item.querySelector(".card__content[href]");
      return link ? link.getAttribute("href").split("?")[0] : "";
    })
    .join("|");
}

class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          "upsell-product-recommendations"
        );

        if (recommendations) {
          if (recommendations.innerHTML.trim().length == 0) {
            fetch(this.dataset.fallbackurl)
              .then((response) => response.text())
              .then((text) => {
                html.innerHTML = text;
                const recommendations = html.querySelector(
                  "upsell-product-recommendations"
                );
                if (!recommendations) return;
                // GARP-160 — skip the replacement when the fetched product
                // set matches what's already rendered, or when the fetch
                // returned no products but the element is already populated.
                const currentFp = fingerprintRecommendations(this);
                const fetchedFp = fingerprintRecommendations(recommendations);
                if (fetchedFp === currentFp) return;
                if (fetchedFp === "" && currentFp !== "") return;
                this.innerHTML = recommendations.innerHTML;
                if (
                  !this.querySelector("slideshow-component") &&
                  this.classList.contains("complementary-products")
                ) {
                  this.remove();
                }
                if (html.querySelector(".grid__item")) {
                  this.classList.add("product-recommendations--loaded");
                  refreshInlineRatings();
                  requestAnimationFrame(refreshInlineRatings);
                }
              });
          } else {
            // GARP-160 — see fallback branch above for rationale.
            const currentFp = fingerprintRecommendations(this);
            const fetchedFp = fingerprintRecommendations(recommendations);
            if (fetchedFp === currentFp) return;
            if (fetchedFp === "" && currentFp !== "") return;
            this.innerHTML = recommendations.innerHTML;
            if (
              !this.querySelector("slideshow-component") &&
              this.classList.contains("complementary-products")
            ) {
              this.remove();
            }
            if (html.querySelector(".grid__item")) {
              this.classList.add("product-recommendations--loaded");
              refreshInlineRatings();
              requestAnimationFrame(refreshInlineRatings);
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define(
  "upsell-product-recommendations",
  UpsellProductRecommendations
);

class CrossellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          "crossell-product-recommendations"
        );

        if (recommendations) {
          if (recommendations.innerHTML.trim().length == 0) {
            fetch(this.dataset.fallbackurl)
              .then((response) => response.text())
              .then((text) => {
                html.innerHTML = text;
                const recommendations = html.querySelector(
                  "crossell-product-recommendations"
                );
                if (!recommendations) return;
                // GARP-160 — skip the replacement when the fetched product
                // set matches what's already rendered, or when the fetch
                // returned no products but the element is already populated.
                const currentFp = fingerprintRecommendations(this);
                const fetchedFp = fingerprintRecommendations(recommendations);
                if (fetchedFp === currentFp) return;
                if (fetchedFp === "" && currentFp !== "") return;
                this.innerHTML = recommendations.innerHTML;
                if (
                  !this.querySelector("slideshow-component") &&
                  this.classList.contains("complementary-products")
                ) {
                  this.remove();
                }
                if (html.querySelector(".grid__item")) {
                  this.classList.add("product-recommendations--loaded");
                  refreshInlineRatings();
                  requestAnimationFrame(refreshInlineRatings);
                }
              });
          } else {
            // GARP-160 — see fallback branch above for rationale.
            const currentFp = fingerprintRecommendations(this);
            const fetchedFp = fingerprintRecommendations(recommendations);
            if (fetchedFp === currentFp) return;
            if (fetchedFp === "" && currentFp !== "") return;
            this.innerHTML = recommendations.innerHTML;
            if (
              !this.querySelector("slideshow-component") &&
              this.classList.contains("complementary-products")
            ) {
              this.remove();
            }
            if (html.querySelector(".grid__item")) {
              this.classList.add("product-recommendations--loaded");
              refreshInlineRatings();
              requestAnimationFrame(refreshInlineRatings);
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define(
  "crossell-product-recommendations",
  CrossellProductRecommendations
);

class ShopTheLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("shop-look");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item, .slider__slide")) {
          this.classList.add("shop-look--loaded");
        }

        var shopLookGrid = this.querySelector(".shop-the-look-product-grid");
        var shopLookGridChildren =
          shopLookGrid?.querySelectorAll(".grid__item");

        var shopLookSlider = this.querySelector("shop-look ul.slider");
        var shopLookSliderChildren = shopLookSlider?.querySelectorAll(
          ".grid__item.slider__slide"
        );

        if (shopLookGridChildren?.length > 0) {
          this.closest(".shop-the-look-container")?.classList.remove("hidden");
        } else {
          this.closest(".shop-the-look-container")?.classList.add("hidden");
        }

        if (shopLookSliderChildren?.length > 0 || Shopify.designMode) {
          this.closest(".carousel")?.classList.remove("hidden");
        } else {
          this.closest(".carousel")?.classList.add("hidden");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("shop-look", ShopTheLook);

class RecentlyViewed extends HTMLElement {
  /*
    data-full_width="{{ full_width }}"
    data-max_cards_to_output="{{ max_cards_to_output }}"
    data-sectionid="{{ section.id }}"
    data-columns_desktop="{{ columns_desktop }}"
    data-columns_mobile="{{ columns_mobile }}"
    data-feature_card_enabled="{{ section.settings.feature_card_enabled }}"
    data-recently_is_only_tab="{{ recently_is_only_tab }}"
    data-on_product_page="{{ on_product_page }}"
  */

  constructor() {
    super();
  }

  config = {
    maxToShow: parseInt(this.dataset.max_cards_to_output),
    minToShow: 1,
    howManyToStoreInMemory: parseInt(this.dataset.max_cards_to_output),
    numberProducts: 0,
    onComplete: null,
  };
  productHandleQueue = [];

  cookie = {
    name: "shopify_recently_viewed",
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(","));
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = localStorage.getItem(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(",");
      }
      return recentlyViewed;
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      let position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  finalize = () => {
    // Add and remove classes that depend on the number of cards

    // Get elements
    const sliderComponent = this.querySelector("slider-component");
    const sliderUL = this.querySelector("slider-component ul.slider");
    const featureWrap = document.querySelector(
      `#shopify-section-${this.dataset.section_id}.carousel__feature-wrap`
    );
    const max_cards_to_output = this.config.maxToShow;

    // Hide buttons if cards fit
    const columns_desktop = parseInt(this.dataset.columns_desktop);
    const columns_mobile = parseInt(this.dataset.columns_mobile);
    let cards_fit_desktop = sliderUL.children.length <= columns_desktop;
    const cards_fit_mobile = sliderUL.children.length <= columns_mobile;
    const feature_card_enabled = this.dataset.feature_card_enabled === "true";
    if (feature_card_enabled) {
      cards_fit_desktop = sliderUL.children.length < columns_desktop;
    } else {
      cards_fit_desktop = sliderUL.children.length <= columns_desktop;
    }

    if (cards_fit_desktop) {
      sliderComponent.classList.add("slider-component--cards-fit-desktop");
    } else {
      sliderComponent.classList.remove("slider-component--cards-fit-desktop");
    }

    if (cards_fit_mobile) {
      sliderComponent.classList.add("slider-component--cards-fit-mobile");
    } else {
      sliderComponent.classList.remove("slider-component--cards-fit-mobile");
    }

    if (featureWrap) {
      if (cards_fit_desktop) {
        featureWrap.classList.add("carousel__feature-wrap--cards-fit-desktop");
      } else {
        featureWrap.classList.remove(
          "carousel__feature-wrap--cards-fit-desktop"
        );
      }
    }

    if (this.dataset.full_width === "true") {
      // set full_width class on parent
      sliderComponent.classList.add("slider-component-full-width");
      sliderComponent.classList.remove("page-width");

      // Add dummy list items for padding

      /*
      const li = document.createElement('li');
      li.setAttribute('aria-hidden', 'true');
      li.setAttribute('class', 'slider__slide first-dummy');
      li.innerHTML = '<!--fake padding-->';

      const li_2 = document.createElement('li');
      li_2.setAttribute('aria-hidden', 'true');
      li_2.setAttribute('class', 'slider__slide last-dummy');
      li_2.innerHTML = '<!--fake padding-->';
      */

      sliderUL.prepend(li);
      sliderUL.appendChild(li_2);
    } else {
      sliderComponent.classList.remove("slider-component-full-width");
      sliderComponent.classList.add("page-width");
    }

    sliderUL.scrollLeft = 0;
    this.classList.add("recently-viewed--loaded");
  };

  getRecentProducts = async () => {
    let searchRecentlyUrl;
    let productHandle;

    if (window.location.pathname.indexOf("/products/") !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];
      this.productHandleQueue = this.productHandleQueue.filter(
        (handle) => productHandle !== handle
      );
    }

    if (this.productHandleQueue.length < this.config.minToShow) {
      return;
    }
    this.config.numberProducts = this.productHandleQueue.length;

    this.productHandleQueue.length = this.config.maxToShow;
    searchRecentlyUrl =
      "/search?view=ua_recently-viewed&q=" + this.productHandleQueue.toString();
    await fetch(searchRecentlyUrl)
      .then((response) => response.text())
      .then((html) => {
        document.querySelector(
          `#shopify-section-${this.dataset.sectionid} recently-viewed`
        ).innerHTML = html;
        this.finalize();
      })
      .catch((err) => {
        console.warn("Something went wrong.", err);
      });
  };

  recordRecentlyViewed = (values) => {
    let vals = values || {};
    let recentlyViewed = this.cookie.read();
    let productHandle;
    let position;

    // Update defaults.
    this.config = { ...this.config, ...vals };

    // If we are on a product page.
    if (window.location.pathname.indexOf("/products/") !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];

      position = recentlyViewed.indexOf(productHandle);

      if (position === -1) {
        recentlyViewed.unshift(productHandle);

        recentlyViewed = recentlyViewed.splice(
          0,
          this.config.howManyToStoreInMemory
        );
      } else {
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      this.cookie.write(recentlyViewed);
    }
  };

  showRecentlyViewed = (parameters) => {
    // Hide whole carousel if only tab and nothing to show
    const recently_is_only_tab = this.dataset.recently_is_only_tab === "true";
    const sectionid = this.dataset.section_id;
    const carousel = document.querySelector(".carousel.section-" + sectionid);
    const product_handles_list = localStorage.getItem(
      "shopify_recently_viewed"
    );
    if (this.dataset.on_product_page === "true") {
      const product_handle = this.dataset.product_handle;
      const no_recently_viewed =
        !product_handles_list ||
        product_handles_list == "" ||
        product_handles_list == product_handle;
      if (recently_is_only_tab && no_recently_viewed && carousel) {
        carousel.classList.add("hidden");
      } else {
        const no_recently_viewed =
          !product_handles_list || product_handles_list == "";
        if (recently_is_only_tab && no_recently_viewed && carousel) {
          carousel.classList.add("hidden");
        }
      }
    }

    let params = parameters || {};
    // Update defaults.
    this.config = { ...this.config, ...params };

    // Read cookie.
    this.productHandleQueue = this.cookie.read();

    if (
      this.productHandleQueue === null ||
      this.productHandleQueue === undefined
    ) {
      return false;
    }

    this.config.maxToShow = Math.min(
      this.productHandleQueue.length,
      this.config.maxToShow
    );

    if (this.config.maxToShow) {
      this.getRecentProducts().then();
    }
  };

  connectedCallback() {
    this.showRecentlyViewed();
    this.recordRecentlyViewed();
  }
}

customElements.define("recently-viewed", RecentlyViewed);

// Video Trigger
if (!customElements.get("video-trigger")) {
  class VideoTrigger extends HTMLElement {
    constructor() {
      super();

      this.video = document.querySelector(this.dataset.video);

      this.addEventListener("click", (e) => {
        e.preventDefault();
        this.playVideo();

        if (this.dataset.hide != null) {
          this.hideContent();
        }
      });
      if (this.hasAttribute("data-pause-on-hover")) {
        this.video.addEventListener("mouseenter", () => {
          this.hoverPauseVideo();
        });

        this.video.addEventListener("mouseleave", () => {
          this.hoverPlayVideo();
        });

        this.video.addEventListener("touchstart", () => {
          this.playVideo();
        });
      }
    }

    hoverPauseVideo() {
      const mediaQuery = window.matchMedia("(min-width: 750px)");

      let videoEl;

      if (mediaQuery.matches) {
        videoEl = this.video.querySelector("[data-desktop-video] video");
      } else {
        videoEl = this.video.querySelector("[data-mobile-video] video");
      }

      if (!videoEl) return;

      videoEl.pause();
      videoEl.setAttribute("data-paused", "true");

      this.toggleState();
    }

    hoverPlayVideo() {
      const mediaQuery = window.matchMedia("(min-width: 750px)");

      let videoEl;

      if (mediaQuery.matches) {
        videoEl = this.video.querySelector("[data-desktop-video] video");
      } else {
        videoEl = this.video.querySelector("[data-mobile-video] video");
      }

      if (!videoEl) return;

      videoEl.play();
      videoEl.setAttribute("data-paused", "false");

      videoEl.addEventListener("ended", this.toggleState.bind(this));

      this.toggleState();
    }

    playVideo() {
      const mediaQuery = window.matchMedia("(min-width: 750px)");

      let videoEl;

      if (mediaQuery.matches) {
        videoEl = this.video.querySelector("[data-desktop-video] video");
      } else {
        videoEl = this.video.querySelector("[data-mobile-video] video");
      }

      if (!videoEl) return;

      if (!this.classList.contains("is-playing")) {
        videoEl.play();
        videoEl.setAttribute("data-paused", "false");
      } else {
        videoEl.pause();
        videoEl.setAttribute("data-paused", "true");
      }

      videoEl.addEventListener("ended", this.toggleState.bind(this));

      this.toggleState();
    }

    toggleState() {
      const playIcon = this.querySelector(".icon-play");
      const pauseIcon = this.querySelector(".icon-pause");

      if (!playIcon && !pauseIcon) return;

      this.classList.toggle("is-playing");

      if (this.classList.contains("is-playing")) {
        pauseIcon.classList.toggle("hidden");
        playIcon.classList.toggle("hidden");
        if (window.videoControls) {
          this.querySelector("b").innerText = window.videoControls.pause;
          this.setAttribute("aria-label", window.videoControls.pause);
        }
      } else {
        pauseIcon.classList.add("hidden");
        playIcon.classList.remove("hidden");
        if (window.videoControls) {
          this.querySelector("b").innerText = window.videoControls.play;
          this.setAttribute("aria-label", window.videoControls.play);
        }
      }
    }

    hideContent() {
      const contentToHide = document.querySelector(this.dataset.hide);
      contentToHide.classList.add("hidden");
    }
  }
  customElements.define("video-trigger", VideoTrigger);
}

// Video Volume
if (!customElements.get("video-volume")) {
  class VideoVolume extends HTMLElement {
    constructor() {
      super();

      this.video = document.querySelector(this.dataset.video);

      if (this.querySelector(".transparent-icon-unmuted")) {
        this.querySelector(".transparent-icon-unmuted").classList.add("hidden");
      }

      this.addEventListener("click", () => {
        this.toggleMute();
      });
    }

    toggleMute() {
      const muteIcon = this.querySelector(".icon-muted");
      const unmuteIcon = this.querySelector(".icon-unmuted");

      const transparentMuteIcon = this.querySelector(".transparent-icon-muted");
      const transparentUnmuteIcon = this.querySelector(
        ".transparent-icon-unmuted"
      );

      if (!muteIcon && !unmuteIcon) return;

      if (!this.video) return;

      const mediaQuery = window.matchMedia("(min-width: 750px)");

      let videoEl;

      if (mediaQuery.matches) {
        videoEl = this.video.querySelector("[data-desktop-video] video");
      } else {
        videoEl = this.video.querySelector("[data-mobile-video] video");
      }

      if (!videoEl) return;

      videoEl.muted = !videoEl.muted;

      if (videoEl.muted) {
        muteIcon.classList.remove("hidden");
        unmuteIcon.classList.add("hidden");
        if (transparentMuteIcon) transparentMuteIcon.classList.remove("hidden");
        if (transparentUnmuteIcon)
          transparentUnmuteIcon.classList.add("hidden");
        this.querySelector("b").innerText = window.videoControls.unmute;
        this.setAttribute("aria-label", window.videoControls.unmute);
      } else {
        muteIcon.classList.add("hidden");
        unmuteIcon.classList.remove("hidden");
        if (transparentMuteIcon) transparentMuteIcon.classList.add("hidden");
        if (transparentUnmuteIcon)
          transparentUnmuteIcon.classList.remove("hidden");
        this.querySelector("b").innerText = window.videoControls.mute;
        this.setAttribute("aria-label", window.videoControls.mute);
      }
    }
  }
  customElements.define("video-volume", VideoVolume);
}

class StickyCards extends HTMLElement {
  constructor() {
    super();
    this.cards = [];
    this.cardCount = 0;
    this.currentCardIndex = 0;
    this.scrollHandler = null;
    this.skipBtn = null;
  }

  connectedCallback() {
    this.render();
    this.init();

    if (this.skipBtn) {
      this.skipBtn.addEventListener("click", () => this.skipToEnd());
    }
  }

  disconnectedCallback() {
    this.removeScrollHandler();
  }

  skipToEnd() {
    const sectionBottom = this.getBoundingClientRect().bottom + window.scrollY;

    window.scrollTo({ top: sectionBottom, behavior: "smooth" });
    this.updateCards(this.cardCount - 1);
  }

  render() {
    // Get all card elements from the light DOM
    const cardElements = this.querySelectorAll(".card");
    this.cardCount = cardElements.length;

    // Apply styles to this component
    this.style.cssText = `
      display: block;
      height: ${this.cardCount * 100}vh;
      position: relative;
    `;

    // Create the sticky container
    const container = document.createElement("div");
    container.className = "sticky-container";
    container.style.cssText = `
      position: sticky;
      top: 0;
      height: 100vh;
      width: 100%;
      overflow: hidden;
    `;

    // Style each card
    cardElements.forEach((card, index) => {
      card.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: translateY(100%);
        transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        z-index: ${index + 1};
      `;

      container.appendChild(card);
    });

    // Move skip button (if present) into sticky-container
    const skipBtn = this.querySelector("#skip-cards");

    if (skipBtn) {
      container.prepend(skipBtn);
      this.skipBtn = skipBtn;
    }

    // Show first card by default
    if (cardElements.length > 0) {
      cardElements[0].style.transform = "translateY(0)";
    }

    // Clear existing content and add container
    //this.innerHTML = "";
    this.appendChild(container);

    // Store card references
    this.cards = Array.from(container.querySelectorAll(".card"));

    // Handle desktop responsive behavior
    this.handleResize();
    window.addEventListener("resize", () => this.handleResize());
  }

  init() {
    if (window.innerWidth >= 768) return; // Desktop fallback

    this.setupScrollHandler();
  }

  handleResize() {
    this.init();
  }

  setupDesktopLayout() {
    const container = this.querySelector(".sticky-container");
    if (container) {
      container.style.cssText = `
        position: relative;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 20px;
        height: auto;
        overflow: visible;
        padding: 20px;
      `;

      this.cards.forEach((card) => {
        card.style.cssText = `
          position: relative;
          height: 400px;
          transform: none;
          z-index: auto;
        `;
      });
    }

    this.style.height = "auto";
  }

  setupMobileLayout() {
    this.style.height = `${this.cardCount * 100}vh`;
    const container = this.querySelector(".sticky-container");
    if (container) {
      container.style.cssText = `
        position: sticky;
        top: 0;
        height: 100vh;
        width: 100%;
        overflow: hidden;
      `;
    }
  }

  setupScrollHandler() {
    if (this.scrollHandler) return;

    this.scrollHandler = () => this.handleScroll();
    window.addEventListener("scroll", this.scrollHandler);
    this.handleScroll(); // Initial call
  }

  removeScrollHandler() {
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
      this.scrollHandler = null;
    }
  }

  handleScroll() {
    const rect = this.getBoundingClientRect();
    const sectionTop = rect.top;
    const sectionHeight = rect.height;
    const viewportHeight = window.innerHeight;

    // Check if we're in the card section
    if (sectionTop <= 0 && sectionTop > -sectionHeight + viewportHeight) {
      const scrollProgress =
        Math.abs(sectionTop) / (sectionHeight - viewportHeight);
      const cardIndex = Math.min(
        Math.floor(scrollProgress * this.cardCount),
        this.cardCount - 1
      );

      this.updateCards(cardIndex);
    }

    document.activeElement.blur();
  }

  updateCards(targetIndex) {
    if (targetIndex === this.currentCardIndex) return;

    // Update card visibility
    this.cards.forEach((card, index) => {
      if (index <= targetIndex) {
        card.style.transform = "translateY(0)";
      } else {
        card.style.transform = "translateY(100%)";
      }
    });

    this.currentCardIndex = targetIndex;
  }
}

// Register the custom element
customElements.define("sticky-cards", StickyCards);

class ProductDescription extends HTMLElement {
  constructor() {
      super();
      this.summary = null;
      this.full = null;
      this.openBtn = null;
      this.closeBtn = null;
      this.initialized = false;
  }
  connectedCallback() {
      this.summary = this.querySelector('[id^="ProductDescriptionSummary-"]');
      this.full = this.querySelector('[id^="ProductDescriptionFull-"]');
      this.openBtn = this.querySelector('[id^="ProductDescriptionToggle-"]:not([id*="Bottom"])');
      this.closeBtn = this.querySelector('[id^="ProductDescriptionToggleBottom-"]');

      if (!this.summary || !this.full || !this.openBtn || !this.closeBtn) return;

      // prevent duplicate listeners if Shopify re-renders same node
      if (this.initialized) return;
      this.initialized = true;

      this.openBtn.addEventListener('click', this.open.bind(this));
      this.closeBtn.addEventListener('click', this.close.bind(this));
  }

  open() {
      this.summary.style.display = 'none';
      this.full.style.display = '';
  }

  close() {
      this.summary.style.display = '';
      this.full.style.display = 'none';

      const isInsideDrawer = this.summary.closest('pdp-info-drawer');

      if (!isInsideDrawer) {
        this.summary.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
  }
}

customElements.define('product-description', ProductDescription);